import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "skc_cookie_consent_v1";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setOpen(true);
    } catch (e) {
      // Private/incognito mode: localStorage.getItem can throw. Skip the
      // banner silently — re-asking on every nav would be worse.
      if (typeof window !== "undefined" && window.console && process.env.NODE_ENV !== "production") {
        console.debug("CookieConsent storage unavailable on read:", e?.message || e);
      }
    }
  }, []);
  if (!open) return null;
  const accept = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    } catch (e) {
      // Private/incognito mode — quota or access denied. Banner still closes.
      if (typeof window !== "undefined" && window.console && process.env.NODE_ENV !== "production") {
        console.debug("CookieConsent storage unavailable:", e?.message || e);
      }
    }
    setOpen(false);
  };
  return (
    <div
      className="fixed bottom-20 left-3 right-3 sm:left-auto sm:right-5 sm:bottom-5 sm:max-w-md z-30 pointer-events-none"
      role="dialog" aria-live="polite" aria-label="Cookie consent"
      data-testid="cookie-banner"
    >
      <div className="pointer-events-auto rounded-2xl shadow-2xl bg-paper border border-rule p-3 sm:p-4 flex items-start gap-2.5 sm:gap-3">
      <Cookie size={18} className="text-signal shrink-0 mt-0.5"/>
      <div className="text-xs sm:text-sm flex-1 min-w-0">
        <p className="font-semibold text-sm">We use only essential cookies.</p>
        <p className="text-muted mt-0.5 text-[11px] sm:text-xs">
          A single first-party JWT keeps you logged in. No third-party ads.
          <Link to="/privacy" className="text-signal underline font-semibold ml-1" data-testid="cookie-privacy-link">Privacy</Link>
        </p>
        <button
          onClick={accept}
          className="mt-2 btn-primary text-xs py-1.5 px-3"
          data-testid="cookie-accept"
        >
          Got it
        </button>
      </div>
      <button
        onClick={accept}
        aria-label="Dismiss"
        className="text-muted hover:text-default shrink-0"
        data-testid="cookie-dismiss"
      >
        <X size={16}/>
      </button>
      </div>
    </div>
  );
}
